// @flow
import { DOWNLOAD_LINKS_LIST } from 'Client/cms/toolkit/constants';
import { DownloadLinksListLine } from 'Components/lines/download-links-list-line/DownloadLinksListLine.jsx';

export const downloadLinksListDescriptor = {
  name: DOWNLOAD_LINKS_LIST,
  component: DownloadLinksListLine,
};
